// "Elements" rail panel: tiles that add an element to the selected section on
// click, or wherever they are dropped on the page when dragged.

import React from "react";
import FeatherIcon from "feather-icons-react";

export const DRAG_MIME = "application/x-td-element";

const TILES = [
  { group: "Text", items: [
    { key: "text", type: "text", label: "Text", icon: "type", opts: { runs: [{ text: "Your text" }] } },
    { key: "heading", type: "text", label: "Heading", icon: "bold", opts: { runs: [{ text: "Invoice" }], style: { fontSize: 16, fontWeight: 700, color: "primary" } } },
    { key: "field", type: "text", label: "Invoice data", icon: "hash", opts: { runs: [{ text: "Invoice # " }, { field: "invoice.number" }] } },
    { key: "keyValue", type: "keyValue", label: "Details list", icon: "list" },
    { key: "propertiesList", type: "propertiesList", label: "Properties", icon: "home" },
  ] },
  { group: "Invoice", items: [
    { key: "lineTable", type: "lineTable", label: "Line items", icon: "grid" },
    { key: "totals", type: "totals", label: "Totals", icon: "dollar-sign" },
  ] },
  { group: "Images & shapes", items: [
    { key: "logo", type: "image", label: "My logo", icon: "award" },
    { key: "image", type: "image", label: "Image", icon: "image", upload: true },
    { key: "rect", type: "shape", label: "Rectangle", icon: "square", opts: { shape: "rect" } },
    { key: "ellipse", type: "shape", label: "Ellipse", icon: "circle", opts: { shape: "ellipse" } },
    { key: "line", type: "shape", label: "Line", icon: "minus", opts: { shape: "line" } },
  ] },
  { group: "Layout", items: [
    { key: "row", type: "row", label: "Columns", icon: "columns", flowOnly: true },
    { key: "divider", type: "divider", label: "Divider", icon: "minus-square" },
    { key: "spacer", type: "spacer", label: "Spacer", icon: "move" },
  ] },
];

export default function ElementsPanel({ onAdd, onAddBand, onUploadImage, targetLabel }) {
  return (
    <div className="td-panel">
      <p className="td-hint">
        Click to add to <strong>{targetLabel || "the page"}</strong>, or drag onto the page.
      </p>
      {TILES.map((g) => (
        <div key={g.group} className="td-tiles">
          <div className="td-tiles__title">{g.group}</div>
          <div className="td-tiles__grid">
            {g.items.map((tile) => (
              <button
                key={tile.key}
                type="button"
                className="td-tile"
                draggable={!tile.upload}
                onDragStart={(e) => {
                  e.dataTransfer.effectAllowed = "copy";
                  e.dataTransfer.setData(DRAG_MIME, JSON.stringify({ type: tile.type, opts: tile.opts || {} }));
                }}
                onClick={() => (tile.upload ? onUploadImage() : onAdd(tile.type, tile.opts || {}))}
                title={tile.flowOnly ? `${tile.label} — flowing sections only` : tile.label}
              >
                <FeatherIcon icon={tile.icon} size={18} />
                <span>{tile.label}</span>
              </button>
            ))}
          </div>
        </div>
      ))}
      <div className="td-tiles">
        <div className="td-tiles__title">Sections</div>
        <div className="td-tiles__grid td-tiles__grid--2">
          <button type="button" className="td-tile" onClick={() => onAddBand("free")} title="A fixed-height area where you place things exactly">
            <FeatherIcon icon="crop" size={18} />
            <span>Free section</span>
          </button>
          <button type="button" className="td-tile" onClick={() => onAddBand("flow")} title="An area where things stack and grow — for tables and notes">
            <FeatherIcon icon="align-justify" size={18} />
            <span>Flowing section</span>
          </button>
        </div>
      </div>
    </div>
  );
}
